export default __webpack_public_path__ + "static/media/img-5.19c3240b.jpg";